module.exports = __webpack_public_path__ + "static/media/paw.fa804cba.svg";